'use strict';

import 'angular';

import formModule from '../form';
import errorsDirective from './directive';

const MODULE_NAME = 'brg.rest.errors';

var app = angular.module(MODULE_NAME, [
	'ngMessages',
	formModule
]);
app.directive('brgRestErrors', errorsDirective);

export default MODULE_NAME;
